import cx from 'clsx';
import React, { Suspense, lazy } from 'react';

import GhostTile from '@/components/modular-grid/GhostTile';
import { GameClickProps, GameTileProps } from '@/components/modular-grid/types';
import { handleClick } from '@/components/modular-grid/utils';
import { CategoryFinancialWebAttributes } from '@/types/category/categoryTypes';

import styles from './TopGames.module.scss';

interface TopGamesProps {
  gameList?: GameTileProps[];
  onClick: (args: { gamePosition: number; game: GameClickProps }) => void;
  onInfoClick: (args: {
    gamePosition: number;
    game: GameClickProps;
    path: string;
  }) => void;
  gameDetailsInfo?: boolean;
  gameInfoTooltip?: string;
  categoryAttributes?: CategoryFinancialWebAttributes;
}

const ModularGridGameTile = lazy(() =>
  import(
    /* webpackChunkName: "ModularGridGameTile" */
    '../ModularGridGameTile'
  )
);

export default function TopGames({
  gameList,
  onClick,
  onInfoClick,
  gameDetailsInfo,
  gameInfoTooltip,
  categoryAttributes,
}: TopGamesProps) {
  if (!gameList) return null;

  return (
    <div className={cx(styles.layout)}>
      {gameList.map((item, index) => {
        return (
          <div
            className={cx(styles.counter)}
            data-index={index + 1}
            key={item.id}
          >
            <Suspense fallback={<GhostTile />}>
              <ModularGridGameTile
                game={item}
                data-testid="counted-tile"
                onClick={handleClick(index, onClick)}
                onInfoClick={handleClick(index, onInfoClick)}
                outfit={'medium'}
                gameDetailsInfo={gameDetailsInfo}
                gameInfoTooltip={gameInfoTooltip}
                isLazy
                isAnchor
                categoryAttributes={categoryAttributes}
                shouldShowJackpot={false}
                tileSize={'vertical'}
              />
            </Suspense>
          </div>
        );
      })}
    </div>
  );
}
